<template>
  <div>
    <!-- Filters -->
    <v-layout row justify-end wrap class="mb-5">
      <v-flex xs12 md3>
        <div class="ml-3">
          <v-autocomplete
            clearable
            v-model="filters.clavedat"
            :items="[{ text: 'Mostrar todas', value: null }].concat(companiesList)"
            :label="$t('Empresa')"
          ></v-autocomplete>
        </div>
      </v-flex>
      <v-flex xs12 md2>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.month"
            item-text="text"
            item-value="value"
            :items="availableMonthsForQuarter"
            :clearable="true"
            row
            :label="$t('Mes del año')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md2>
        <div class="ml-3">
          <v-select
            v-if="invoiceType === 'factura'"
            color="primary"
            v-model="filters.blocked"
            item-text="text"
            item-value="value"
            :items="[
              { text: 'Todos los estados', value: null },
              { text: 'Contabilizadas', value: 'blocked' },
              { text: 'No contabilizadas', value: 'editable' },
            ]"
            :clearable="true"
            row
            :label="$t('Estado contable')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md2>
        <div class="ml-3">
          <!-- <v-select
            color="primary"
            v-model="filters.payment_method"
            item-text="text"
            item-value="value"
            :items="availablePaymentMethods"
            :clearable="true"
            row
            :label="$t('Forma de pago')"
          ></v-select> -->
          <v-select
            color="primary"
            v-model="filters.doc_type"
            item-text="text"
            item-value="value"
            :items="documentTypes"
            :clearable="true"
            row
            :label="$t('Tipo de documento')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md3>
        <div class="ml-3">
          <v-text-field
            v-model="filters.search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row justify-end wrap class="mb-5">
      <v-flex xs12 md3>
        <div class="ml-3">
          <v-switch
            class="right"
            v-model="filters.show_my_customers"
            label="Solo mis clientes"
          ></v-switch>
        </div>
      </v-flex>
    </v-layout>
    <!-- Data table with invoices -->
    <v-data-table
      ref="openBillingInvoiceTable"
      v-model="selectedItems"
      :loading="loading"
      :headers="headers"
      :items="invoices"
      :pagination.sync="invoicesPagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="invoicesPagination.totalItems"
      select-all
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" icon="info" outline>
          {{ $t('No hay información que mostrar con los filtros seleccionados :(') }}
        </v-alert>
      </template>
      <template v-slot:headers="props">
        <tr>
          <th v-if="props.headers.length > 0">
            <v-checkbox
              v-model="selectAllRows"
              @change="selectAllTableRows()"
              primary
              hide-details
            ></v-checkbox>
          </th>
          <template v-for="header in props.headers">
            <th
              :key="`th_${header.value}`"
              :class="[
                'text-xs-center',
                header.sortable ? 'column sortable' : '',
                invoicesPagination.descending ? 'desc' : 'asc',
                header.value === invoicesPagination.sortBy ? 'active' : '',
              ]"
              @click="header.sortable ? changeSort(header.value) : null"
            >
              <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </template>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td>
            <v-checkbox
              v-model="props.selected"
              @change="onSelectItem"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td v-for="header in headers" :key="header.value" class="text-xs-center">
            <template v-if="header.value === 'tax_base'">
              {{
                props.item[header.value]
                  .toFixed(2)
                  .toString()
                  .replace('.', ',') + '€'
              }}
            </template>
            <template v-else-if="header.value === 'total_amount'">
              {{
                props.item[header.value]
                  .toFixed(2)
                  .toString()
                  .replace('.', ',') + '€'
              }}
            </template>
            <template v-else-if="header.value === 'blocked' && props.item[header.value]">
              <v-tooltip top>
                <v-icon slot="activator" color="green">
                  mdi-check
                </v-icon>
                <span>{{ formatBlockedDateTime(props.item[header.value]) }}</span>
              </v-tooltip>
            </template>
            <template v-else-if="header.value === 'status' && props.item[header.value]">
              <v-chip :color="getColorForStatus(props.item[header.value])" text-color="white">
                <strong>{{ props.item[header.value] }}</strong>
              </v-chip>
            </template>
            <template v-else>
              {{ props.item[header.value] }}
            </template>
          </td>
          <td class="text-xs-center">
            <v-icon small class="mr-3" @click="showInvoice(props.item)">
              mdi-eye
            </v-icon>
            <v-icon small class="mr-3" @click="downloadPdf(props.item)">
              mdi-download
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
const moment = require('moment');
require('moment/locale/es');
import apiCtrl from '@/services/api/abstract/abstract-api';
import EmpresaAPI from '../../aplifisa/services/fiscal';

export default {
  name: 'OpenBillingInvoiceTable',
  components: {},
  props: ['year', 'quarter', 'companyStatus', 'nonPayment', 'invoiceType'],
  data() {
    return {
      invoices: [],
      selectedItems: [],
      selectAllRows: false,
      loading: false,
      headers: [],
      companiesList: [],
      availableMonthsForQuarter: [],
      availablePaymentMethods: [
        { text: 'No definido', value: 'No definido' },
        { text: 'Efectivo', value: 'Efectivo' },
        { text: 'Bizum', value: 'Bizum' },
        { text: 'Transferencia', value: 'Transferencia' },
        { text: 'Tarjeta bancaria', value: 'Tarjeta bancaria' },
        { text: 'Domiciliación bancaria', value: 'Domiciliación bancaria' },
        { text: 'Paypal', value: 'Paypal' },
      ],
      documentTypes: [
        { text: 'Todos', value: null },
        { text: 'Factura', value: 'factura' },
        { text: 'Tickets', value: 'ticket' },
      ],
      invoicesPagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      filters: {
        search: '',
        status: '',
        clavedat: null,
        year: this.year,
        quarter: this.quarter,
        company_status: this.companyStatus,
        non_payment: this.nonPayment,
        month: null,
        payment_method: '',
        blocked: null,
        show_my_customers: false,
        doc_type: null,
      },
      sortTable: false,
    };
  },
  mounted() {
    this.getBillingInvoices();
    this.getCompaniesList();
    this.getAvailableMonthsForQuarter();
  },
  computed: {
    currentPage() {
      return this.invoicesPagination.page;
    },
    perPage() {
      return this.invoicesPagination.rowsPerPage;
    },
    sortBy() {
      return this.invoicesPagination.sortBy;
    },
    descending() {
      return this.invoicesPagination.descending;
    },
    selectedYear() {
      return this.year;
    },
    selectedQuarter() {
      return this.quarter;
    },
    search() {
      return this.filters.search;
    },
    status() {
      return this.filters.status;
    },
    blocked() {
      return this.filters.blocked;
    },
    clavedat() {
      return this.filters.clavedat;
    },
    month() {
      return this.filters.month;
    },
    paymentMethod() {
      return this.filters.payment_method;
    },
    showMyCustomers() {
      return this.filters.show_my_customers;
    },
    documentType() {
      return this.filters.doc_type;
    },
  },
  methods: {
    getColorForStatus(status) {
      switch (status) {
        case 'Impagada':
          return '#FF3333';
        case 'Pendiente':
          return '#53BDFF';
        case 'Cobrada':
          return '#00CC33';
        case 'Aceptado':
          return '#53BDFF';
        case 'Facturado':
          return '#00CC33';
        case 'Rechazado':
          return '#FF3333';
        case 'Rectificada':
          return '#999999';
        default:
          return '#CCCCCC';
      }
    },
    formatBlockedDateTime(dateTime) {
      return moment(dateTime).format('DD/MM/YYYY HH:mm');
    },
    getBillingInvoices() {
      this.loading = true;
      this.selectAllRows = false;
      this.selectedItems = [];
      const config = {
        params: {
          page: this.invoicesPagination.page,
          per_page: this.invoicesPagination.rowsPerPage,
          sort_by: this.invoicesPagination.sortBy,
          descending: this.invoicesPagination.descending,
          search: this.search,
          status: this.status,
          clavedat: this.clavedat,
          month: this.month,
          year: this.selectedYear,
          quarter: this.selectedQuarter,
          company_status: this.companyStatus,
          non_payment: this.nonPayment,
          payment_method: this.paymentMethod,
          doc_type: this.documentType,
          blocked: this.blocked,
          show_my_customers: this.showMyCustomers,
        },
      };
      apiCtrl
        .get(`/adminbilling/invoices/list`, config)
        .then(res => {
          this.invoices = res.data.data;
          this.headers = res.data.dataTable.headers.filter(header => header.value !== 'status');
          this.invoicesPagination = {
            descending: this.invoicesPagination.descending,
            page: this.invoicesPagination.page,
            rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
            sortBy: this.invoicesPagination.sortBy,
            totalItems: Number(res.data.meta.total),
          };
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getCompaniesList() {
      EmpresaAPI.getFiscalDataInputSelect().then(response => {
        this.companiesList = response.data;
      });
    },
    selectAllTableRows() {
      if (
        this.selectedItems.length === 0 ||
        (this.selectedItems.length >= 1 && this.selectedItems.length < this.invoices.length)
      ) {
        let selected = [];
        this.invoices.forEach(item => {
          selected.push(item);
        });
        this.selectedItems = selected;
      } else if (this.selectedItems.length === this.invoices.length) {
        this.selectedItems = [];
      }
    },
    changeSort(column) {
      if (this.invoicesPagination.sortBy === column) {
        this.invoicesPagination.descending = !this.invoicesPagination.descending;
      } else {
        this.invoicesPagination.sortBy = column;
        this.invoicesPagination.descending = false;
      }
    },
    showInvoice(invoice) {
      this.$emit('on-show-invoice', invoice);
    },
    getBillingInvoicesIfStopChanges() {
      this.loading = true;
      const params = {
        page: this.invoicesPagination.page,
        per_page: this.invoicesPagination.rowsPerPage,
        search: this.filters.search,
      };

      setTimeout(() => {
        if (
          params.page === this.invoicesPagination.page &&
          params.per_page === this.invoicesPagination.rowsPerPage &&
          params.search === this.filters.search
        ) {
          this.getBillingInvoices();
        }
      }, 300);
    },
    getAvailableMonthsForQuarter() {
      let months;
      switch (this.selectedQuarter) {
        case 1:
          months = [
            { text: 'Enero', value: 1 },
            { text: 'Febrero', value: 2 },
            { text: 'Marzo', value: 3 },
          ];
          break;
        case 2:
          months = [
            { text: 'Abril', value: 4 },
            { text: 'Mayo', value: 5 },
            { text: 'Junio', value: 6 },
          ];
          break;
        case 3:
          months = [
            { text: 'Julio', value: 7 },
            { text: 'Agosto', value: 8 },
            { text: 'Septiembre', value: 9 },
          ];
          break;
        case 4:
          months = [
            { text: 'Octubre', value: 10 },
            { text: 'Noviembre', value: 11 },
            { text: 'Diciembre', value: 12 },
          ];
          break;
        default:
          months = [
            { text: 'Enero', value: 1 },
            { text: 'Febrero', value: 2 },
            { text: 'Marzo', value: 3 },
            { text: 'Abril', value: 4 },
            { text: 'Mayo', value: 5 },
            { text: 'Junio', value: 6 },
            { text: 'Julio', value: 7 },
            { text: 'Agosto', value: 8 },
            { text: 'Septiembre', value: 9 },
            { text: 'Octubre', value: 10 },
            { text: 'Noviembre', value: 11 },
            { text: 'Diciembre', value: 12 },
          ];
      }
      this.availableMonthsForQuarter = months;
    },
    downloadPdf(invoice) {
      this.$emit('on-download-pdf', invoice);
    },
    onSelectItem(value) {
      if (!value && this.selectAllRows) {
        this.selectAllRows = false;
      }
    },
  },
  watch: {
    search: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    currentPage: function() {
      this.getBillingInvoicesIfStopChanges();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    sortBy: function() {
      if (this.sortBy != null && this.sortTable) {
        this.getBillingInvoices();
      } else {
        if (this.descending === null) {
          this.sortTable = false;
        }
      }
    },
    descending: function() {
      if (this.descending != null) {
        this.getBillingInvoices();
        this.sortTable = true;
      } else {
        if (this.sortBy === null) {
          this.sortTable = false;
        }
      }
    },
    blocked: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    clavedat: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    month: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    selectedYear: function() {
      this.filters.year = this.selectedYear;
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    selectedQuarter: function() {
      this.filters.month = null;
      this.filters.quarter = this.selectedQuarter;
      this.getAvailableMonthsForQuarter();
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    companyStatus: function() {
      this.filters.company_status = this.companyStatus;
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    nonPayment: function() {
      this.filters.non_payment = this.nonPayment;
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    selectedItems: function() {
      this.$emit('on-selected-items', this.selectedItems);
    },
    paymentMethod: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    showMyCustomers: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    documentType: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
  },
};
</script>

<style scoped></style>
